import React, { useState } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

function ActionMenu (props) {
  const [ anchorEl, setAnchorEl ] = useState(null);

  const actionMnuShow = ev => {
    ev.stopPropagation();
    setAnchorEl(ev.currentTarget);
  }

  const actionMnuClose = ev => {
    ev.stopPropagation();
    setAnchorEl(null);
  }

  const delBookmark = ev => {
    actionMnuClose(ev);
    props.delBookmark(props.bookmark.id);
  }

  const openBookmark = ev => {
    actionMnuClose(ev);
    props.openBookmark(props.bookmark.link);
  }

  return(
    <div onClick={ev => {ev.preventDefault()}}>
      <IconButton onClick={actionMnuShow}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={actionMnuClose}
      >
      <MenuItem onClick={openBookmark}>Otwórz</MenuItem>
      <MenuItem onClick={delBookmark}>Usuń</MenuItem>
    </Menu>
    </div>
  );
}

export default ActionMenu;